const styles = {
  container:
    'group hover:bg-[#F6FBFC] hover:cursor-pointer duration-200 mt-4 lg:mt-5 fixed w-full bg-[#D9F2F7] z-20   text-sm py-3 text-[#29AAC7]',
  content: 'flex flex-row items-center gap-x-1 !text-xs sm:text-sm',
};

export default styles;
